<template>
  <v-dialog v-if="request" v-model="show" max-width="500px" scrollable>
    <v-card>
      <v-carousel>
        <v-carousel-item
          v-for="(file, i) in request.files"
          :key="i"
          height="500px"
          eager
        >
          <vue-pdf-embed
            v-if="file.mime_type === 'application/pdf'"
            :source="file.url"
          />
          <v-img v-else :src="file.responsive_url" />
        </v-carousel-item>
      </v-carousel>

      <v-card-title>
        <h4>Request Details</h4>
        <v-spacer></v-spacer>
        <v-btn icon @click="show = false">
          <v-icon>{{ close }}</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pb-0 mt-2" style="height: 200px;">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>File Owner</v-list-item-title>
            <v-list-item-subtitle>{{
              request.user.full_name
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>File Type</v-list-item-title>
            <v-list-item-subtitle>{{
              request.template ? request.template.label : 'Custom - No Template'
            }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>File Name</v-list-item-title>
            <v-list-item-subtitle>{{ request.name }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list flat subheader three-line>
          <v-list-item
            v-for="(requestInformationType,
            i) in request.file_information_types"
            :key="i"
          >
            <v-list-item-content>
              <v-list-item-title>{{
                requestInformationType.label
              }}</v-list-item-title>
              <v-list-item-subtitle>{{
                requestInformationType.value
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Last Updated</v-list-item-title>
              <v-list-item-subtitle>{{
                request.updatedDate
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Status</v-list-item-title>
              <v-list-item-subtitle
                ><v-chip
                  class="ma-2"
                  :color="
                    request.status === 'valid'
                      ? '#D1FFEF'
                      : request.status === 'rejected'
                      ? '#FFE2E2'
                      : '#FFF3CC'
                  "
                >
                  <span
                    class="text-capitalize"
                    :class="
                      request.status === 'valid'
                        ? 'green--text'
                        : request.status === 'rejected'
                        ? 'red--text'
                        : 'yellow--text text--darken-4'
                    "
                    >{{ request.status }}</span
                  >
                </v-chip></v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions right>
        <v-container fluid>
          <v-row align="center">
            <v-col v-for="(option, i) in options" :key="i" align-self="center">
              <v-btn
                block
                :color="i < 1 ? 'primary' : 'none'"
                class="text-capitalize"
                :loading="loading"
                @click="getReason(option)"
              >
                {{ option }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <ReasonModal
      :status="form.status"
      v-model="showReasonModal"
      @verify="showConfirmation"
    />
    <ConfirmationModal
      v-model="showConfirmationModal"
      @verify="verifyRequest"
    />
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" right>
      {{ snackbar.message }}
      <v-btn color="white" text @click="snackbar.show = false">Ok</v-btn>
    </v-snackbar>
  </v-dialog>
</template>
<script>
import ConfirmationModal from './ConfirmationModal'
import ReasonModal from './ReasonModal'
import Form from '@/utils/form'
import { mdiClose } from '@mdi/js'

import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  components: {
    ConfirmationModal,
    ReasonModal,
    VuePdfEmbed
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    request: {
      type: Object,
      default: null
    }
  },

  computed: {
    options() {
      if (this.request.status === 'valid') {
        return ['pending approval', 'reject']
      } else if (this.request.status === 'rejected') {
        return ['valid', 'pending approval']
      }

      return ['valid', 'reject']
    }
  },

  data() {
    return {
      loading: false,
      close: mdiClose,
      show: this.value,
      showConfirmationModal: false,
      showReasonModal: false,
      form: new Form({
        status: '',
        reason: ''
      }),
      snackbar: {
        show: false,
        message: null,
        color: null
      }
    }
  },

  methods: {
    getReason(option) {
      this.showReasonModal = true
      this.form.status = option
    },
    async verifyRequest() {
      if (this.form.status === 'reject') {
        this.form.status = 'rejected'
      }

      await this.$api
        .post(`admin/files/${this.request.id}/verify`, this.form.$data())
        .then(({ data }) => {
          this.$emit('showResponse', data.data.status)
          this.form.$reset()
        })
    },
    showConfirmation(reason) {
      this.showConfirmationModal = true
      this.form.reason = reason
    }
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)
    },

    showConfirmationModal(val) {
      if (!val) {
        this.loading = false
      }
    },

    showReasonModal(val) {
      if (!val) {
        this.loading = false
      }
    }
  }
}
</script>
